import { render, staticRenderFns } from "./PageSlot.vue?vue&type=template&id=3e037126&scoped=true"
import script from "./PageSlot.vue?vue&type=script&lang=js"
export * from "./PageSlot.vue?vue&type=script&lang=js"
import style0 from "./PageSlot.vue?vue&type=style&index=0&id=3e037126&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e037126",
  null
  
)

export default component.exports